import React from 'react';
import VgClientPlacedAd from './VgClientPlacedAd';

/* eslint-disable */
export default ({ clientPlacedAds }) => (
    <VgClientPlacedAd
        subtype="sponsorstripe"
        clientPlacedAds={clientPlacedAds}
        visibleOnError={false}
    />
);
/* eslint-disable */



/** WEBPACK FOOTER **
 ** ./src/local-components/Ads/SponsorAd.js
 **/